import { ReactNode } from 'react';

import { Icon, Text } from '@pukka/ui-components';
import { twMerge } from 'tailwind-merge';
import { ZodError } from 'zod';

interface FormInputProps {
  readonly label: string;
  readonly description?: string;
  readonly error?: string | boolean | ZodError;
  readonly required?: boolean;
  readonly className?: string;
  readonly children: ReactNode;
}

function FormInput({ label, description, required, error, className, children }: FormInputProps) {
  let errorString = '';

  if (typeof error === 'string') {
    errorString = error;
  } else if (error instanceof ZodError) {
    errorString = error.errors[0].message;
  } else if (required) {
    errorString = 'This is a required question';
  }

  return (
    <div className={twMerge('mb-4', className)}>
      <label>
        <Text as="span" variant="subtitle-1" weight="medium" className="block">
          {label}
          {required ? (
            <Text as="span" className="text-red-500">
              *
            </Text>
          ) : null}
        </Text>
        {description ? (
          <Text as="span" variant="caption-2" color="neutral" className="-mt-0.5 block">
            {description}
          </Text>
        ) : null}
        <div className="mt-2">{children}</div>
      </label>
      {error ? (
        <div className="mt-1 flex flex-row items-center">
          <Icon icon="info" color="red" size="sm" />
          <Text variant="caption-1" className="ml-1 text-red-500">
            {errorString}
          </Text>
        </div>
      ) : null}
    </div>
  );
}

export { FormInput };
